import * as THREE from 'three';

/**
 * CloudSystem — Floating cloud planes at Y~180.
 * 25 cloud patches using PlaneGeometry with semi-transparent white material.
 * Slowly drift across the sky, wrapping around the player.
 */
export class CloudSystem {
  constructor(scene) {
    this.scene = scene;
    this.clouds = [];
    this._speed = 2; // blocks per second drift
    this._group = new THREE.Group();
    scene.add(this._group);

    const cloudMat = new THREE.MeshBasicMaterial({
      color: 0xFFFFFF,
      transparent: true,
      opacity: 0.6,
      side: THREE.DoubleSide,
      depthWrite: false,
      fog: true,
    });

    for (let i = 0; i < 25; i++) {
      const w = 20 + Math.random() * 40;
      const d = 15 + Math.random() * 30;
      const geo = new THREE.PlaneGeometry(w, d);
      const mat = cloudMat.clone();
      mat.opacity = 0.3 + Math.random() * 0.4;
      const cloud = new THREE.Mesh(geo, mat);
      cloud.rotation.x = -Math.PI / 2; // horizontal
      cloud.position.set(
        (Math.random() - 0.5) * 500,
        170 + Math.random() * 20,
        (Math.random() - 0.5) * 500
      );
      this._group.add(cloud);
      this.clouds.push(cloud);
    }
  }

  update(dt, playerPos) {
    for (const cloud of this.clouds) {
      cloud.position.x += this._speed * dt;
      // Wrap around player
      if (cloud.position.x > playerPos.x + 300) {
        cloud.position.x = playerPos.x - 300;
        cloud.position.z = playerPos.z + (Math.random() - 0.5) * 500;
      }
    }
  }

  setVisible(visible) {
    this._group.visible = visible;
  }

  dispose() {
    for (const cloud of this.clouds) {
      cloud.geometry.dispose();
      cloud.material.dispose();
    }
    this.scene.remove(this._group);
    this.clouds.length = 0;
  }
}
